module.exports = __webpack_public_path__ + "static/media/Subtract.d1557cac.svg";